module.exports = __webpack_public_path__ + "img/36.d49051b9.png";